module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Du åpnet opp Praksis","subtitle":"Start ferden til nye vaner i {title} med daglig scenariotrening.","button":"Gjør ditt daglige scenario"},"en":{"title":"You unlocked Practice","subtitle":"Start your journey for good {title} habits with daily scenario training.","button":"Do your daily scenario"}}')
  delete Component.options._Ctor
}
